import { render, staticRenderFns } from "./change-customs-info.vue?vue&type=template&id=91d52b22&scoped=true"
import script from "./change-customs-info.vue?vue&type=script&lang=js"
export * from "./change-customs-info.vue?vue&type=script&lang=js"
import style0 from "./change-customs-info.vue?vue&type=style&index=0&id=91d52b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d52b22",
  null
  
)

export default component.exports